import React from 'react';
import Profile from '../assets/profile.jpg';
import { BsArrowRightShort } from "react-icons/bs";
import { Link } from "react-scroll";

const Home = () => {
  return (
    <div name= "home" 
    className="md-h-screen w-full pt-32 text-white bg-gradient-to-r from-sky-950 via-slate-800 to-slate-900">
    {/* background color gradient from top to bottom the middle part will be black then gray*/}
      
      <div className="max-w-screen-lg px-9 md:py-5 mx-auto flex flex-col
       items-center justify-center h-full md:flex-row">
        <div className="flex flex-col justify-center">
      <h2 className="text-4xl text-white sm:text-7xl font-bold">
         Hi, I’m Eden <br/> Kefale
          </h2>
        <p className= "text-white py-4 max-w-md"> 
       A UI/UX designer passionate about clean, functional design.<br/>
       Based in Addis Ababa, Ethiopia.
       I help turn ideas into user-friendly interfaces.
        </p>
        
        <div>
          <Link to="portfolio" smooth duration={500}  className= "group font-medium text-white w-fit px-6 py-2 my-1 flex items-center rounded-md bg-slate-500 cursor-pointer to-blur-900">
              Portfolio 
              <span className="group-hover:rotate-90 duration-300">
            <BsArrowRightShort size={25} className='ml-l'/>
              </span>
          </Link>
          </div>
        </div>

 {/* image */}
 <div>
        <img 
        src = {Profile} 
        alt = "Profile"
        className="w-96 max-w-full mx-auto rounded-sm mt-9 md:w-96 md:ml-28 md:mt-0"/>
    </div>
    </div>
    </div>
 
  );
};

export default Home;